import React from "react";
import { Link } from "react-router-dom";


export function Rights()
{
    return (
<>
        <div className="d-flex justify-content-center align-items-center flex-wrap text-white gap-2 pt-2" style={{backgroundColor: "#333333"}}>
            <Link to="page/תקנון-האתר" className="text-white">תקנון האתר</Link>  &nbsp;|&nbsp; 
            <Link to="page/מדיניות-פרטיות" className="text-white">מדיניות פרטיות</Link>  &nbsp;|&nbsp; 
            <Link to="page/הצהרת-נגישות" className="text-white">הצהרת נגישות</Link>  &nbsp;|&nbsp; 

            <Link to="mailto:ozovadia@gmail.com" className="text-white">
                פיתוח אתר  &nbsp;
                <img src="/img/oz_logo.png" className="logo bg-white" alt="Oz Aviad Logo"/> &nbsp;
                &copy; עוז אביעד&nbsp;|&nbsp; 
            </Link>
            <Link to="mailto:ozovadia@gmail.com" className="text-white">
                 Powered by <span style={{color: 'lightblue'}}>Super</span><span style={{color: 'gold'}}>Commerce</span> &nbsp;
                {/* <img src="/img/supercommerce_logo.png" className="logo bg-white" alt=" Logo"/> &nbsp; */}
            </Link>
        </div>
        </>
    )

}